module.exports = __webpack_public_path__ + "static/img/login-l.0643001.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/login-l.png
// module id = V5HT
// module chunks = 1